(function () {
  const p = (window.location.pathname || '').replace(/\/+$/, '');

  const isDealerDetail = p.startsWith('/a/store-locator/') && p.endsWith('.html');
  const isListing = (p === '/pages/haendlersuche' || p === '/pages/probeliegen');
  if (!isDealerDetail && !isListing) return;

  // Nur laufen, wenn es etwas zu befüllen gibt
  let briefing = '';
  try { briefing = localStorage.getItem('mmc_briefing') || localStorage.getItem('mmc_config') || ''; } catch (e) {}
  if (!briefing) return;

  const STORAGE_KEYS = ['mmc_config', 'mmc_briefing', 'mmc_payload'];

  function getValueSetter(el) {
    let proto = el;
    while (proto) {
      const desc = Object.getOwnPropertyDescriptor(proto, 'value');
      if (desc && typeof desc.set === 'function') return desc.set;
      proto = Object.getPrototypeOf(proto);
    }
    return null;
  }

  function setNativeValue(el, value) {
    const setter = getValueSetter(el);
    if (setter) setter.call(el, value);
    else el.value = value;

    try { el.defaultValue = value; } catch (e) {}
    try { el.setAttribute('value', value); } catch (e) {}

    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function attachClearOnSubmit(form) {
  if (!form || form.dataset.mmcClearAttached === '1') return;

  const clear = () => {
    try {
      STORAGE_KEYS.forEach(k => localStorage.removeItem(k));
    } catch (e) {}
  };

  // 1) klassischer Submit (falls vorhanden)
  form.addEventListener('submit', () => {
    clear();
  }, { once: true });

  // 2) AJAX-Forms: Klick auf Submit-Button abfangen
  const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
  submitButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      // leicht verzögert, damit Validierung/Framework noch arbeiten kann
      setTimeout(clear, 50);
    }, { once: true });
  });

  form.dataset.mmcClearAttached = '1';
}

  function tryFill() {
    const field =
      document.querySelector('#ifystorelocator_comment') ||
      document.querySelector('textarea[name="comment"]') ||
      document.querySelector('textarea[placeholder*="Kommentar" i]');

    if (!field) return false;

    const prefix = "Wunschkonfiguration Modulmatratze:\n\n";
    const closing = "\n\nBitte kontaktieren Sie mich, um einen Beratungstermin zu vereinbaren.";
    const desired = `${prefix}${briefing}${closing}`.trim();

    const current = (field.value || '').trim();
    if (!current.includes(briefing)) {
      setNativeValue(field, desired + (current ? "\n\n" + current : ""));
    }

    attachClearOnSubmit(field.closest('form'));
    return true;
  }

  // Sofort versuchen (Detailseite klappt direkt)
  if (tryFill()) return;

  // Listing: Kontakt erscheint abhängig vom User-Klick
  document.addEventListener('click', () => { tryFill(); }, true);

  // Backup: falls die App das Formular ohne Klick nachrendert
  const obs = new MutationObserver(() => {
    if (tryFill()) {
      try { obs.disconnect(); } catch (e) {}
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();